export default "__VITE_ASSET__DyqFkyyl__"